export const LIMITS = {
    chatTitle: 20,
    chatTitleError: "Chat title must be between 1 and 20 characters",
    newMessageTitle: 50,
    newMessageTitleError: "New message title must be less than 51 characters",
    welcomeMsg: 200,
    welcomeMsgError: "Welcome message must be between 1 and 200 characters",
    offlineWelcomeMsg: 200,
    offlineWelcomeMsgError: "Offline welcome message must be between 1 and 200 characters",
    PROMPT: 150,
    PATH: 500,
    messageError: "Must be between 1 and 150 characters",
    pathError: "Must be less than 500 characters",
    title: 50,
    titleError: "Title must be less than 51 characters",
    inboxEmail: 100,
    inboxEmailError: "Email must be between 1 and 100 characters",
    displayEmail: 35,
    displayEmailError: "Email must be between 1 and 35 characters",
    phoneNumber: 20,
    phoneNumberError: "Phone number must be between 1 and 20 characters",
    address: 35,
    addressError: "Address must be between 1 and 35 characters",
    recaptchaPublicKey: 100,
    recaptchaPublicKeyError: "Public key must be between 1 and 100 characters",
    recaptchaPrivateKey: 100,
    recaptchaPrivateKeyError: "Private key must be between 1 and 100 characters",
    OPTION: 150,
    REPLY: 500,
    optionError: "Must be between 1 and 150 characters",
    replyError: "Must be between 1 and 500 characters"
}